<template>
  <modal
    v-bind="$attrs"
    :scrollable="true"
    :class="{
      [$attrs.name]: true,
    }"
    class="modal-wrapper"
    v-on="$listeners"
  >
    <slot name="before-content" />
    <div class="modal-wrapper__content">
      <slot name="content" />
    </div>
    <slot name="after-content" />
  </modal>
</template>
<script>
export default {
  name: 'modal-wrapper',
};
</script>
<style lang="scss">
.modal-wrapper {
  &__content {
    margin: 20px 0;
    max-height: calc(100vh - 40px);
    border-radius: 3px;
    overflow: hidden;
    background: #fff;
  }
}
.vm--modal {
  background: none !important;
  box-shadow: none !important;
}
</style>
